const api = require("@/module_user/api/api.js").default;
const baseUrl = process.env.VUE_APP_API_URL;

exports.getAchievementList = async ({ page, pageSize }) => {
  let query = `page=${page}&pageSize=${pageSize}`;
  return await api.get(baseUrl + `/admin/achievement?${query}`);
};

exports.createAchievement = async (data) => {
  return await api.post(baseUrl + `/admin/achievement`, data);
};

exports.updateAchievement = async (id, data) => {
  return await api.put(baseUrl + `/admin/achievement/${id}`, data);
};

exports.deleteAchievement = async (id) => {
  return await api.delete(baseUrl + `/admin/achievement/${id}`);
};
